export enum PublishChannel {
  ALL = 'all',
  NEWS = 'news',
  SUCCESSFUL_CASES = 'successful_cases',
  HIGHLIGHTS = 'highlights',
  INDUSTRIAL_REPORTS = 'industrial_reports',
  HELPS = 'helps',
  MOGUL_SHARING = 'mogul_sharing',
  FAQ = 'faq',
  HELPS_MANUAL = 'helps_manual',
  HELPS_FAQS = 'helps_faqs',
}
export const CHANNELS = [
  // { label: '全部', value: PublishChannel.ALL },
  { label: '成功案例', value: PublishChannel.SUCCESSFUL_CASES },
  // { label: '历史活动', value: PublishChannel.HIGHLIGHTS },
  { label: '行业报告', value: PublishChannel.INDUSTRIAL_REPORTS },
  { label: '大咖分享', value: PublishChannel.MOGUL_SHARING },
];

export const getChannelName = (key: string) => {
  return CHANNELS.find(item => item.value === key)?.label;
};

export enum CONTENT_TYPE {
  VIDEO = 'video',
  RTF = 'rtf',
  ATTACHMENT = 'attachment',
}

export enum PUBLISH_STATUS {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

export interface ContentItem {
  id: string;
  title: string;
  brief_intro: string;
  publish_channel: PublishChannel;
  cover?: string;
  content_type: CONTENT_TYPE;
  display_time?: number;
  update_time: string;
  tags?: string[];
  video?: { preview_url?: string; url?: string };
  rich_text?: string;
  attachments?: { name?: string; url?: string };
  preview?: { name?: string; url?: string };
  mogul_info?: { titles?: string[]; name?: string };
  source?: string;
}

export interface ContentPageItemProps {
  id: string;
  channel: string;
  title?: string;
}

export interface ContentContextInfo {
  next: ContentPageItemProps;
  prev: ContentPageItemProps;
}

const DEFAULT_PARAMS = {
  publish_status: 'published',
  _page: 1,
  _num: 9,
};

export const getDefaultparams = (publish_channel: string) => ({ publish_channel, ...DEFAULT_PARAMS });
export const PLAY_ICON = 'https://static.fuxi.netease.com/yaotai/portal/20220530/l3shkp2k_play.png';
